import { message } from "antd";
import { mySalaryList, detail } from '../../../../services/salary/mySalary';

const initState = () => {
  return {
    statusList: [{ readState: '1', status: '已阅' }, { readState: '0', status: '未阅' }],
    list: [],
    queries: {}, // 搜索条件
    // 分页信息
    pageInfo: {
      page: 1,
      pageSize: 10,
      totalElements: 1,
      totalPages: 1,
    },
    // 加载信息
    spinProps: {
      spinning: false,
      tip: '加载中...',
    },
    detailsData: {},
  };
};

export default {
  namespace: 'mySalary',

  state: initState(),

  effects: {
    *fetchSearch({ payload }, { call, put }) {
      try {
        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: true,
              tip: '加载中...',
            },
          },
        });

        const response = yield call(mySalaryList, payload);

        const { content, page, pageSize, totalElements, totalPages } = response;
        yield put({
          type: 'save',
          payload: {
            list: content,
            pageInfo: {
              page,
              pageSize,
              totalElements,
              totalPages,
            },
            spinProps: {
              spinning: false,
            },
          },
        });
      } catch (error) {
        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: false,
            },
          },
        });
      }
    },
    // 详情
    *fetchDetail({ payload }, { call, put }) {
      try {
        const data = yield call(detail, payload);
        const { contentTitle = [], content = [] } = data
        let columns = [], dataSource = []
        contentTitle.map((item, index) => {
          if (item.trim().length) {
            let a = {};
            a.title = item;
            a.dataIndex = `columns${index}`;
            a.key = `columns${index}`;
            a.width = 130;
            a.render = data => {
              if (!data) {
                return '-';
              }
              return data
            }
            columns.push(a);
          }
        });
        content.map(item => {
          const { salarySheetDetailExtendValue } = item;
          let b = {};
          salarySheetDetailExtendValue.map((subitem, index) => {
            b['columns' + index] = subitem;
          });
          dataSource.push(b);
        })
        data.columns = columns;
        data.dataSource = dataSource;
        yield put({
          type: "save",
          payload: {
            detailsData: data,
          }
        });
        return Promise.resolve();
      } catch (error) {
        return Promise.reject();
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return { ...initState };
    },
  },
};
